module.exports = __webpack_public_path__ + "static/media/Etan,35@2x.db968c1b.png";